import React, { useMemo } from "react";

// Servisni sloj
import { getUsersAPI } from "services/api/users/api";
import { UserRow } from "services/api/users/types";
import { DataWithPagination } from "services/api";
import { PaginationDirection } from "services/url";
import { DropdownCacheKey, useDropdownCache } from "services/hooks/useDropdownCache";

// UI
import { Dropdown } from "../Dropdown";
import { DropdownOption } from "../Dropdown/types";

import { UserDropdownProps } from "./types";

const FIVE_MINUTES = 5 * 60 * 1000;

/**
 * Odabir korisnika aplikacije. Korisnici se ne kreiraju odavde — samo biraju,
 * kao i kod poslovnica.
 */
const UserDropdown: React.FC<UserDropdownProps> = (props) => {
  const {
    name,
    disabled,
    required,
    label,
    error,
    value,
    direction,
    width,
    height,
    placeholder,
    cssClassName,
    onChange,
  } = props;

  const { data } = useDropdownCache<DataWithPagination<UserRow>>(
    DropdownCacheKey.Users,
    () =>
      getUsersAPI({
        pageNumber: 1,
        pageSize: 500,
        sort: { sortBy: "firstName", direction: PaginationDirection.Ascending },
      }),
    FIVE_MINUTES
  );

  const options: DropdownOption[] = useMemo(
    () =>
      (data?.data ?? []).map((user) => ({
        value: user.id,
        text: `${user.firstName ?? ""} ${user.lastName ?? ""}`.trim() || user.email,
      })),
    [data]
  );

  return (
    <Dropdown
      label={label}
      name={name}
      disabled={disabled}
      required={required}
      placeholder={placeholder}
      value={value}
      direction={direction}
      width={width}
      height={height}
      options={options}
      onChange={onChange}
      error={error}
      cssClassName={cssClassName}
    />
  );
};

export default React.memo(UserDropdown);
